import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import HowToLayout from './HowToLayout';

class HowToProfile extends Component {
    render() {
        return (
            <HowToLayout title="Profile">
                <p className="howto-intro">
                    Your profile is how other members see you on AniMates. The <strong className="howto-strong">Profile</strong> tab is also home to your account settings — where you update your info, change your display name, and manage your account.
                </p>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Editing Your Profile</h3>
                    <p className="howto-paragraph">
                        Tap <strong className="howto-strong">Edit Profile</strong> to update your community profile — your banner and profile photo, your About Me, your top anime and what you're currently watching, and your gender (which you can keep hidden). You can also set visibility options here, like who's allowed to message you and whether your hosted and attended events are shown. Save when you're done and your changes appear right away.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Changing Your Display Name</h3>
                    <p className="howto-paragraph">
                        In the <strong className="howto-strong">Display Name</strong> section, tap <strong className="howto-strong">Change</strong>, enter a new name, and tap <strong className="howto-strong">Save and Update</strong>. Display names can be up to 25 characters and use letters, numbers, underscores, and periods — no spaces. Because names are unique, there's a cooldown between changes; premium members can reset the cooldown to change sooner.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Account Settings</h3>
                    <p className="howto-paragraph">
                        Tap the <strong className="howto-strong">gear</strong> icon on your Profile to open <strong className="howto-strong">Account Settings</strong>, where you can pause or delete your account. This screen also handles things like updating your email, verifying your account, updating your location, and managing your membership.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Pausing Your Account</h3>
                    <p className="howto-paragraph">
                        Need a break? Tap <strong className="howto-strong">Pause Account</strong>. Pausing hides your profile, removes you from events, and cancels any events you're hosting — but keeps your followers, friends, stats, and history safe. You can come back anytime with <strong className="howto-strong">Reactivate Account</strong>. (Founding Member status is kept while you're paused.)
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Deleting Your Account</h3>
                    <p className="howto-paragraph">
                        <strong className="howto-strong">Delete Account</strong> permanently removes your profile, events, messages, and history — this can't be undone, and Founding Member status and any legacy pricing are lost for good. If you're unsure, consider pausing instead. You can also manage your account from the website on the <Link to="/pause-account" className="howto-link">Pause Account</Link> and <Link to="/delete-account" className="howto-link">Delete Account</Link> pages.
                    </p>
                </section>

                <p className="howto-footer-note">
                    Still need a hand? Email <a href="mailto:hello@animates.app" className="howto-link">hello@animates.app</a>.
                </p>
            </HowToLayout>
        );
    }
}

export default HowToProfile;
